import { createSlice, createAction } from '@reduxjs/toolkit';
import initialState from '../../../domain/entities/offices';

const fetchOffices = createAction('fetchOffices');

function fetchOfficesSuccess(state, action) {
  const { offices } = action.payload;

  state.offices = offices;
  state.successFetching = true;
  state.errorFetching = false;
}

function fetchOfficesError(state) {
  state.offices = [];
  state.successFetching = false;
  state.errorFetching = true;
}

const officesReducer = createSlice({
  name: 'offices',
  initialState,
  reducers: {
    fetchOfficesSuccess,
    fetchOfficesError,
  },
});

export const officesActions = {
  ...officesReducer.actions,
  fetchOffices,
};

export default officesReducer.reducer;
